import React, { Component } from 'react';
import { observer } from 'mobx-react';
import AiVideoDetail from 'biz-micro-services-ui/project/aiCreation/pages/aiVideoDetail/index';

@observer
class AiVideoDetailView extends Component {
  render() {
    const { location } = this.props;

    // 解析 URL 参数
    const searchParams = new URLSearchParams(location.search);
    const caseId = searchParams.get('caseId') || searchParams.get('id');
    console.log('caseId', caseId);
    return (
      <AiVideoDetail
        {...this.props}
        params={{
          caseId,
          simplifiedMode: true // 简化模式：隐藏tab和滑动
        }}
      />
    );
  }
}

export default AiVideoDetailView;



// WEBPACK FOOTER //
// ./src/pages/AICreation/AiVideoDetail/AiVideoDetailView.js